import { KINDRED_SUPPORT_EMAIL } from "./legalLinks";

export const SUPPORT_KINDRED_ROUTE = "/support/kindred";
export const SUPPORT_KINDRED_SHARE_URL = "https://kindredcommunity.app";
export const SUPPORT_KINDRED_GOFUNDME_URL =
  "https://www.gofundme.com/f/a-supportive-community-for-single-parents";
export const SUPPORT_KINDRED_FACEBOOK_URL =
  "https://www.facebook.com/share/1AXiDhxx7d/?mibextid=wwXIfr";
export const SUPPORT_KINDRED_EMAIL_LINK = `mailto:${KINDRED_SUPPORT_EMAIL}`;

export const SUPPORT_KINDRED_PAGE = {
  menuTitle: "Support Kindred",
  menuSubtitle: "Open Support to help keep Kindred free to use and easy to share.",
  featureTitle: "Support Kindred",
  featureDescription:
    "If you're able, help keep Kindred free to access for single and sole parents.",
  pageTitle: "Support this App, if you're able",
  pageSubtitle:
    "Crowdfunding keeps Kindred free to access for single and sole parents.",
  pageMeta: "Every contribution helps 🙏",
  intro: [
    "Kindred is a supportive community for single parents that we want to keep free to use. There are ongoing costs to build and maintain the app. If you are able, please consider contributing via GoFundMe so we can remain crowdfunded instead of adding subscriptions.",
    "Any and all donations are appreciated. Thank you for helping us keep the community thriving.",
  ],
  helpTitle: "Other ways to help",
  helpSubtitle: "Small actions still make a real difference to the community.",
  sharePrompt: "Invite single or solo parents to join the community.",
  thankYou: "Thank you for your support!",
} as const;
